import React from "react";
const Newsletter = () => {
    return (
        <>
            {/* News-Letter Start Here */}
            <section className="news-letter">
                <div className="container">
                    <div className="newsletter-satrt">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="letter-text" data-aos="fade-left" data-aos-duration="1000">
                                    <span className="small-heading">Subscribe to our Newsletter</span>
                                    <h2 className="lg-heading">Get Access to Latest News</h2>
                                    <p className='text mb-0 para-extra-color'>Receive news and updates by subscribing to our newsletter today.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 pt-4 pt-lg-0" data-aos="fade-right" data-aos-duration="1000">
                                <div className="new-letter-form d-flex justify-content-start justify-content-lg-center flex-column h-100">
                                    <form action="" method="post">
                                        <div className="form-group">
                                            <input type="email" name="" id="" placeholder='Enter Email' />
                                            <button className='btn px-5 ms-auto d-block w-xs-100 button-color-1'>Subscribe Now</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* News-Letter End Here */}
        </>
    )
}
export default Newsletter;